import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { LeftoverCellProps } from '../types';
import { mapLocalizedEnumOptions } from '../../../../../../utils';
import { UnitType } from '../../../../../../generated/graphql';
import { TableHeadSelect, TableHeadSortToggle } from '../../../../../../ui-kit';


const WarehouseLeftoversHeaderContent = ({
    storageUnit,
    setStorageUnit,
    leftoversSort,
    setLeftoversSort
}: LeftoverCellProps) => {
    const { t } = useTranslation();
    const options = mapLocalizedEnumOptions(t)({ UnitType });

    return (
        <Box display='flex' alignItems='center'>
            <Box px={1}>
                <TableHeadSortToggle setSort={setLeftoversSort} sort={leftoversSort} />
            </Box>
            <TableHeadSelect
                fullWidth
                label={t('Leftovers')}
                value={storageUnit}
                onChange={setStorageUnit}
                options={options}
            />
        </Box>
    );
};

export default WarehouseLeftoversHeaderContent;